export default __webpack_public_path__ + "static/media/linkedIn_icon.38731e31.png";